/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SavedLocation } from "./SavedLocation";
import {
  SavedLocationFromJSON,
  SavedLocationFromJSONTyped,
  SavedLocationToJSON,
  SavedLocationToJSONTyped,
} from "./SavedLocation";

/**
 *
 * @export
 * @interface HubbleCompaniesServiceGetBranchesResponse
 */
export interface HubbleCompaniesServiceGetBranchesResponse {
  /**
   *
   * @type {Array<SavedLocation>}
   * @memberof HubbleCompaniesServiceGetBranchesResponse
   */
  items: Array<SavedLocation>;
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceGetBranchesResponse
   */
  currentUserBranchId?: string | null;
}

/**
 * Check if a given object implements the HubbleCompaniesServiceGetBranchesResponse interface.
 */
export function instanceOfHubbleCompaniesServiceGetBranchesResponse(
  value: object,
): value is HubbleCompaniesServiceGetBranchesResponse {
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function HubbleCompaniesServiceGetBranchesResponseFromJSON(
  json: any,
): HubbleCompaniesServiceGetBranchesResponse {
  return HubbleCompaniesServiceGetBranchesResponseFromJSONTyped(json, false);
}

export function HubbleCompaniesServiceGetBranchesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleCompaniesServiceGetBranchesResponse {
  if (json == null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(SavedLocationFromJSON),
    currentUserBranchId:
      json["currentUserBranchId"] == null
        ? undefined
        : json["currentUserBranchId"],
  };
}

export function HubbleCompaniesServiceGetBranchesResponseToJSON(
  json: any,
): HubbleCompaniesServiceGetBranchesResponse {
  return HubbleCompaniesServiceGetBranchesResponseToJSONTyped(json, false);
}

export function HubbleCompaniesServiceGetBranchesResponseToJSONTyped(
  value?: HubbleCompaniesServiceGetBranchesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items: (value["items"] as Array<any>).map(SavedLocationToJSON),
    currentUserBranchId: value["currentUserBranchId"],
  };
}
